<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'intake-estimate-list'"
    v-if="loaded"
    :defaultUserSettings="false"
    class="intake-estimate-list-view"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../../templates/transaction-list";
import { IntakeEstimateService } from "../../../_services/api/purchasing/intake-estimate/intake-estimate.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      PurchaseOrderScreenVersion: "V1",
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Intake Estimate",
        // ScreenName: "Intake Estimate - All",

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoIntakeEstimateList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Intake Estimates",
                message: "Get Started, Add a Intake Estimate",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/intake-estimate/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "EstimateSeason",
              allowHiding: false,
              type: "Integer",
              filterIndex: 0,
              width: ColumnWidth.SeasonYear.width + 20,
              minWidth: ColumnWidth.SeasonYear.minWidth + 20,
              forceWidth: true,
            },
            {
              screenField: "EstimateDescription",
              label: "Name",
              type: "Text",
              filterIndex: 1,
              filterLabel: "Name",
              width: ColumnWidth.CompanyName.width + 50,
              minWidth: ColumnWidth.CompanyName.minWidth + 50,
            },
            {
              screenField: "Narration",
              filterIndex: 2,
              type: "Text",
              textOperators: true,
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
              encodeHtml: false,
              minWidth: ColumnWidth.Comment.minWidth,
            },
            {
              screenField: "TotalKg",
              label: "Tonnes",
              width: ColumnWidth.Weight.width,
              minWidth: ColumnWidth.Weight.minWidth,
              customizeText: function (cellInfo) {
                if (cellInfo.value != null) {
                  const value = (cellInfo.value / 1000).toFixed(0);
                  // Add thousand separators
                  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                  return cellInfo.value;
                }
              },
            },
            {
              screenField: "EstimateDate",
              allowSearch: true,
              filterIndex: 3,
              sortOrder: "desc",
              sortIndex: 0,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "DateCreated",
              visible: false,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "DateCreated",
              visible: false,
              label: "Date Changed",
              dataField: "DateChanged",
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "CreatedBy",
              visible: false,
              width: ColumnWidth.CreatedBy.width,
              minWidth: ColumnWidth.CreatedBy.minWidth,
            },
            {
              screenField: "ChangedBy",
              visible: false,
              width: ColumnWidth.CreatedBy.width,
              minWidth: ColumnWidth.CreatedBy.minWidth,
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              width: 50,
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Copy Estimate",
                      data: data,
                      clickAction: this.copyEstimate,
                      visible: true,
                    },
                    {
                      menuText: "Generate Purchase Forecast",
                      data: data,
                      clickAction: this.gereratePurchaseForecast,
                      visible: true,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (!data) return true;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "intake-estimate",
          mode: "review",
          idProperty: "RecordId",
        });
      }
    },

    async copyEstimate(e, grid) {
      await IntakeEstimateService.copyEstimate({
        RecordId: e.RecordId,
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          // this.$logger.debug("result ", result);
          grid.refresh(true);
        })
        .catch((error) => {
          this.displayServerError(error, "Copy Estimate Failed");
        });
    },

    async gereratePurchaseForecast(e) {
      await IntakeEstimateService.generatePurchaseForecast({
        IntakeEstimates: [{ RecordId: e.RecordId }],
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          this.$notify(`Forecast generated successfully`, "success");
          // this.$logger.debug("result ", result);
          // grid.refresh(true);
        })
        .catch((error) => {
          this.displayServerError(error, "Forecast generation failed");
        });
    },
  },

  async created() {
    this.loaded = true;
  },
};
</script>

<style lang="scss">
.intake-estimate-list-view {
  td {
    vertical-align: top !important;
  }
}
</style>
